import { useMutation } from "@tanstack/react-query";
import creativeStudioApiClient from "../creativeStudio";

/** Uploads one audio track and resolves to its public URL. */
const useUploadCreativeAudioMutation = () =>
  useMutation({
    mutationKey: ["upload-creative-audio"],
    mutationFn: (file: File) => creativeStudioApiClient.uploadAudio(file),
  });

export default useUploadCreativeAudioMutation;
